import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';

import { isNull } from 'lodash-es';
import { map, withLatestFrom } from 'rxjs';
import { filter } from 'rxjs/operators';

import { TooltipEnum } from '../../enums/tooltip';
import { TooltipService } from '../../misc/services/tooltip.service';
import * as fromMapActions from '../actions/map.actions';
import * as fromMapSelectors from '../selectors/map.selectors';
import * as fromOrganizationSelectors from '../selectors/organization.selectors';

@Injectable()
export class MapEffects {
  private actions$ = inject(Actions);
  private store = inject(Store);
  private tooltipService = inject(TooltipService);

  centerOnUserPosition$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromMapActions.centerOnUserPosition),
        withLatestFrom(
          this.store.pipe(select(fromMapSelectors.selectUserPosition)),
          this.store.pipe(select(fromOrganizationSelectors.selectApplicationName))
        ),
        filter((data) => isNull(data[1])),
        map((data) => data[2]),
        map(async (applicationName) => {
          await this.tooltipService.show(
            {
              buttons: [
                {
                  htmlAttributes: {
                    'aria-label': 'close'
                  },
                  icon: 'close',
                  role: 'cancel',
                  side: 'end'
                }
              ],
              message: `You need to grant the ${applicationName} app permission to access your location. This can be done in your device’s privacy settings.`,
              position: 'bottom',
              positionAnchor: 'main-footer'
            },
            TooltipEnum.MapCenterOnUserError
          );
        })
      ),
    {
      dispatch: false
    }
  );
}
